import { selectIsAutobrokerEnabled } from './selectIsAutobrokerEnabled';

import { createSelector } from 'reselect';
import { selectAuction } from './selectAuction';

export const selectIsAuctionEnabled = createSelector(
  [selectAuction, selectIsAutobrokerEnabled],
  (auction, isAutobrokerEnabled) => {
    return auction.isEnabled && !isAutobrokerEnabled;
  },
);
